import dayjs from 'dayjs';

export const formatDICOMTime = (dicomTime?: string | null): string => {
  if (!dicomTime) return '';

  const hh = dicomTime.slice(0, 2);
  const mm = dicomTime.slice(2, 4);
  const ss = dicomTime.slice(4, 6);

  return `${hh}:${mm}:${ss}`;
};

const hasHangul = (value: string): boolean =>
  /[\u3131-\u318E\uAC00-\uD7A3]/.test(value);
const hasLatin1Supplement = (value: string): boolean =>
  /[\u00A1-\u00FF]/.test(value);

export const decodeEucKrMojibake = (value: string): string => {
  if (!hasLatin1Supplement(value) || hasHangul(value)) {
    return value;
  }

  try {
    const bytes = Uint8Array.from(value, (char) => char.charCodeAt(0) & 0xff);
    const decoded = new TextDecoder('euc-kr').decode(bytes);

    return hasHangul(decoded) ? decoded : value;
  } catch {
    return value;
  }
};

export const normalizeDICOMText = (value?: string | null): string => {
  if (!value) return '';

  return decodeEucKrMojibake(value)
    .normalize('NFKC')
    .replace(/[\u0000-\u001F\u007F]/g, '')
    .trim();
};

export const normalizeDICOMPersonName = (value?: string | null): string =>
  normalizeDICOMText(value).replace(/\^+/g, ' ').replace(/\s+/g, ' ').trim();

export const datetimeFormatter = (
  datetime: string | null | undefined,
  format: string,
  addTime = true,
) => {
  if (!datetime) return '';

  return addTime
    ? dayjs(datetime).add(9, 'hour').format(format)
    : dayjs(datetime).format(format);
};

export const base64ToBlob = (data: string): Blob => {
  const arr = data.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1] || ''; // MIME 타입 추출
  const bstr = atob(arr[1]); // Base64 데이터를 디코딩
  const n = bstr.length;
  const u8arr = new Uint8Array(n);

  for (let i = 0; i < bstr.length; i += 1) {
    u8arr[i] = bstr.charCodeAt(i);
  }
  return new Blob([u8arr], { type: mime });
};

export const blobToFile = (blob: Blob, fileName: string): File => {
  return new File([blob], fileName, { type: blob.type });
};

export const filesToFormData = (files: File[]) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));

  return formData;
};
